<template>
  <div class="examApprovalContent" v-loading="loading">
    <div v-if="SubjectiveQuestionForModelExamList[nowIndex]">
      <div v-if="SubjectiveQuestionForModelExamList[nowIndex].children[index]">
        <div class="examApprovalContent-flex-between">
          <div>{{SubjectiveQuestionForModelExamList[nowIndex].student.name}}的考试成绩</div>
          <div class="examApprovalContent-examBox">待审批试卷剩余{{SubjectiveQuestionForModelExamList[nowIndex].examCount}}</div>
        </div>
        <el-row :gutter="20" class="examApprovalContent-top">
          <el-col :span="16">
            <el-card style="min-height:200px">
              <div class="examApprovalContent-flex-between">
                <div class="examApprovalContent-smallSize">题目</div>
                <div class="examApprovalContent-smallSize">{{index+1}}/{{SubjectiveQuestionForModelExamList[nowIndex].children.length}}</div>
              </div>
              <div class="examApprovalContent-top">{{SubjectiveQuestionForModelExamList[nowIndex].children[index].question.title}}</div>
              <div class="examApprovalContent-smallSize examApprovalContent-top">解答</div>
              <div class="examApprovalContent-top" v-html="SubjectiveQuestionForModelExamList[nowIndex].children[index].userAnswer"></div>
            </el-card>
            <el-card class="examApprovalContent-top" style="min-height:200px">
              <div class="examApprovalContent-smallSize">参考答案</div>
              <div class="examApprovalContent-top">{{SubjectiveQuestionForModelExamList[nowIndex].children[index].question.answer}}</div>
            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card style="min-height:420px">
              <div class="examApprovalContent-flex-between">
                <div>
                  <div><span class="examApprovalContent-smallSize">主观题得分：</span>{{totalRuleScore}}/{{SubjectiveQuestionForModelExamList[nowIndex].totalRuleScore}}分</div>
                  <div style="margin-top:10px"><span class="examApprovalContent-smallSize">审批人：</span>{{SubjectiveQuestionForModelExamList[nowIndex].examSettingTeacherName}}</div>
                </div>
                <div class="examApprovalContent-flex">
                  <el-button v-if="previousProBlock" @click="previousPro">上一题</el-button>
                  <el-button v-if="!showSubmitBlock" @click="nextPro">下一题</el-button>
                  <el-button v-if="showSubmitBlock&&showInput" @click="submitSubjectiveQuestionForModelExam">确定</el-button>
                </div>
              </div>
              <div class="examApprovalContent-flex-between examApprovalContent-top" v-for="(item,key) in SubjectiveQuestionForModelExamList[nowIndex].children" :key="key">
                <div class="examApprovalContent-flex">
                  <div :class="item.inputBlock?'examApprovalContent-index-hover':'examApprovalContent-index'">{{key+1}}</div>
                  <div class="examApprovalContent-index-line" style="margin-left:20px" v-if="item.score!=null&&!item.inputBlock||!showInput">得分：{{item.score}}</div>
                  <div v-if="!item.inputBlock&&item.score==null" class="operation-style examApprovalContent-index-line" style="margin-left:20px">待审批</div>
                  <el-input v-if="item.inputBlock&&showInput" class="examApprovalContent-input" placeholder="请输入得分" type="number" v-model="item.score" @blur="scoreChange(item.score,item.ruleScore,key)"></el-input>
                </div>
                <div class="examApprovalContent-index-line"><span class="examApprovalContent-smallSize">满分：</span>{{item.ruleScore}}</div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      showSubmitBlock: false,
      previousProBlock: true,
      loading: true,
      SubjectiveQuestionForModelExamList: [],
      nowIndex: 0,
      index: 0,
      studentExerciseId: null,
      showInput: false,
      totalRuleScore: 0,
      tempTotalRuleScore: 0
    };
  },
  watch: {
  },
  mounted () {
    this.getExaminationQuestionByExerciseId();
  },
  watch: {
    SubjectiveQuestionForModelExamList (val, olaVal) {
      // totalRuleScore

    }
  },
  methods: {
    getExaminationQuestionByExerciseId () {
      this.loading = true;
      this.nowIndex = 0;
      this.index = 0;
      this.totalRuleScore = 0;
      this.tempTotalRuleScore = 0;
      this.showSubmitBlock = false;
      this.api.examStudent.getExaminationQuestionByExerciseId({
        studentExerciseId: this.$route.query.studentExerciseId,
        studentInfoId: this.$route.query.studentInfoId
      }).then(result => {
        if (result.success) {
          if (result.data.updatePermission == 1) {
            this.showInput = true;
          }
          this.SubjectiveQuestionForModelExamList = [result.data];
          this.SubjectiveQuestionForModelExamList.forEach(e => {
            e.children.forEach(c => {
              if (c.score != null) {
                this.totalRuleScore = this.totalRuleScore + c.score;
                this.tempTotalRuleScore = JSON.parse(JSON.stringify(this.tempTotalRuleScore + c.score));
              }
              this.$set(c, "inputBlock", false)
            })
          })
          this.SubjectiveQuestionForModelExamList[this.nowIndex].children[this.index].inputBlock = true;
          if (this.SubjectiveQuestionForModelExamList.length == 1 && this.SubjectiveQuestionForModelExamList[0].children.length == 1) {
            this.previousProBlock = false;
          }
          this.loading = false;
          console.log('this.SubjectiveQuestionForModelExamList[this.nowIndex]', this.SubjectiveQuestionForModelExamList[this.nowIndex])
        } else {
          this.$router.push({ path: "/systemExamResult", query: { activeName: 4 } })
          // this.$router.go(-1)
          this.$message.success(result.message)
        }
      })
    },
    previousPro () {
      if (this.index > 0) {
        this.index = this.index - 1;
        this.SubjectiveQuestionForModelExamList[this.nowIndex].children[this.index + 1].inputBlock = false;
        this.SubjectiveQuestionForModelExamList[this.nowIndex].children[this.index].inputBlock = true;
        this.showSubmitBlock = false;
      } else {
        if (this.nowIndex > 0) {
          this.SubjectiveQuestionForModelExamList[this.nowIndex].children[this.index].inputBlock = false;
          this.nowIndex = this.nowIndex - 1;
          this.index = this.SubjectiveQuestionForModelExamList[this.nowIndex].children.length - 1;
          this.SubjectiveQuestionForModelExamList[this.nowIndex].children[this.index].inputBlock = true;
          this.showSubmitBlock = false;
        }
      }
    },
    nextPro () {
      if (this.SubjectiveQuestionForModelExamList[this.nowIndex].children.length - 1 > this.index) {
        this.index = this.index + 1;
        this.SubjectiveQuestionForModelExamList[this.nowIndex].children[this.index - 1].inputBlock = false;
        this.SubjectiveQuestionForModelExamList[this.nowIndex].children[this.index].inputBlock = true;
        if (this.SubjectiveQuestionForModelExamList.length == this.nowIndex + 1 && this.SubjectiveQuestionForModelExamList[this.nowIndex].children.length == this.index + 1) {
          this.showSubmitBlock = true;
        }
      } else {
        if (this.SubjectiveQuestionForModelExamList.length - 1 > this.nowIndex) {
          this.SubjectiveQuestionForModelExamList[this.nowIndex].children[this.index].inputBlock = false;
          this.nowIndex = this.nowIndex + 1;
          this.index = 0;
          this.SubjectiveQuestionForModelExamList[this.nowIndex].children[this.index].inputBlock = true;
        }
      }
    },
    scoreChange (score, ruleScore, key) {
      if (score < 0) {
        this.$message.error("得分不能为负数！")
        this.SubjectiveQuestionForModelExamList[this.nowIndex].children[key].score = null;
      }
      if (score > ruleScore) {
        this.$message.error("得分不能超过该题总分！")
        this.SubjectiveQuestionForModelExamList[this.nowIndex].children[key].score = null;
      }
      this.totalRuleScore = 0;
      this.SubjectiveQuestionForModelExamList.forEach(e => {
        e.children.forEach(c => {
          if (c.score != null) {
            this.totalRuleScore = Number(this.totalRuleScore) + Number(c.score);
          }
        })
      })
    },
    submitSubjectiveQuestionForModelExam () {
      this.SubjectiveQuestionForModelExamList.forEach(e => {
        let sum = 0;
        e.children.forEach(c => {
          sum = sum + Number(c.score);
        })
        e.score = String(Number(e.score) - Number(this.tempTotalRuleScore) + Number(sum));
      })
      console.log(this.SubjectiveQuestionForModelExamList);

      this.api.question.submitSubjectiveQuestionForModelExam(this.SubjectiveQuestionForModelExamList).then(result => {
        if (result.success) {
          let query = this.$router.history.current.query;
          let path = this.$router.history.current.path;
          //对象的拷贝
          let newQuery = JSON.parse(JSON.stringify(query));
          newQuery.studentExerciseId = null;
          this.$router.push({ path, query: newQuery });
          this.studentExerciseId = "";
          // this.getSubjectiveQuestionByExerciseId();
        } else {
          this.$message.error(result.message)
        }
      })
    },
  },

};
</script>

<style scoped>
.examApprovalContent-flex {
  display: flex;
}
.examApprovalContent-flex-between {
  display: flex;
  justify-content: space-between;
}
.examApprovalContent-examBox {
  border: 1px solid #a2aabc;
  border-radius: 30px;
  padding: 3px 10px;
}
.examApprovalContent-index-line {
  line-height: 40px;
}
.examApprovalContent-index {
  height: 38px;
  width: 38px;
  border: 1px solid rgba(238, 238, 238, 1);
  text-align: center;
  line-height: 38px;
}
.examApprovalContent-index-hover {
  height: 38px;
  width: 38px;
  border: 1px solid rgba(77, 148, 255, 1);
  text-align: center;
  line-height: 38px;
  background: rgba(77, 148, 255, 1);
  color: #fff;
}
.examApprovalContent-index-line {
  line-height: 40px;
}
.examApprovalContent-top {
  margin-top: 20px;
}
.examApprovalContent-smallSize {
  font-size: 13px;
  color: #a2aabc;
}
.examApprovalContent-input {
  width: 100px;
}
</style>




// WEBPACK FOOTER //
// src/components/testSystem/systemAuditPaper.vue